export enum PieceType {
    PAWN = 'pawn',
    BISHOP = 'bishop',
    KNIGHT = 'knight',
    ROOK = 'rook',
    QUEEN = 'queen',
    PRINCESS = 'princess',
    PRINCE = 'prince',
    KING = 'king',
    RETIREDKING = 'retiredking',
}

export enum TeamType {
    OPPONENT = 'b',
    OUR = 'w',
}